import React, { useEffect, useState } from 'react';
import { Select, Button, Typography, message } from 'antd';
import { useTranslation } from 'react-i18next';
import {  useDispatch } from 'react-redux';
import { resetFilters } from './slice/filterSlice';

const { Option } = Select;
const { Text } = Typography;

const currentYear = new Date().getFullYear();
const years = Array.from({ length: currentYear - 2000 + 1 }, (_, i) => 2000 + i);

interface FilterContentProps {
    onApply: (fromYear: number, toYear: number) => void;
    indicatorId: string;
    fromYearDefault: number;
    toYearDefault: number;
}

const yearRangeIndicatorIds = [11, 15, 9, 14];

const FilterContent: React.FC<FilterContentProps> = ({ onApply, indicatorId, fromYearDefault, toYearDefault }) => {
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const defaultFromYear = yearRangeIndicatorIds.includes(parseInt(indicatorId || '0'))
        ? currentYear - 4
        : currentYear;
    const [fromYear, setFromYear] = useState<number>(fromYearDefault);
    const [toYear, setToYear] = useState<number>(toYearDefault);

    useEffect(() => {
        setFromYear(fromYearDefault);
        if (yearRangeIndicatorIds.includes(parseInt(indicatorId))) {
            setToYear(toYearDefault);
        } else {
            setToYear(toYearDefault);
        }

    }, [indicatorId, fromYearDefault]);

    const handleFromYearChange = (year: number) => {
        setFromYear(year);
        if (yearRangeIndicatorIds.includes(parseInt(indicatorId))) {
            setToYear(year + 4); // Automatically set `toYear` to `fromYear + 4`
        }

    };

    const handleToYearChange = (year: number) => {
        setToYear(year);
    };

    const handleApply = () => {
        if (yearRangeIndicatorIds.includes(parseInt(indicatorId))) {
            if (toYear && fromYear && toYear < fromYear) {
                message.error(t('to-year-should-be-greater-than-from-year'));
                return;
            }
        }
        onApply(fromYear, toYear);
    };

    const handleClearFilter = () => {
        dispatch(resetFilters(indicatorId));
        onApply(defaultFromYear, currentYear); // Reset to default values
    };

    return (
        <div style={{ padding: '10px' }}>
            {yearRangeIndicatorIds.includes(parseInt(indicatorId)) ?

                (
                    <>
                        <div style={{ marginBottom: '10px' }}>

                            <Text strong>{t('from.year')}</Text>
                            <Select
                                placeholder={t('select.from.year')}
                                value={fromYear}
                                style={{ width: '100%', marginTop: '5px' }}
                                onChange={handleFromYearChange}
                                showSearch={true}
                                allowClear
                            >
                                {years.map((year) => (
                                    <>
                                        {
                                            indicatorId === '14' ?
                                                <Option key={year} value={year}>
                                                    {year} - {year + 1}
                                                </Option>
                                                :
                                                <Option key={year} value={year}>
                                                    {year}
                                                </Option>
                                        }
                                    </>

                                ))}
                            </Select>
                        </div>
                        <div style={{ marginBottom: '10px' }}>
                            <Text strong>{t('to.year')}</Text>
                            <Select
                                placeholder={t('select.to.year')}
                                value={toYear}
                                style={{ width: '100%', marginTop: '5px' }}
                                onChange={handleToYearChange}
                                disabled={yearRangeIndicatorIds.includes(parseInt(indicatorId))} // Disable when condition is true
                                allowClear={!yearRangeIndicatorIds.includes(parseInt(indicatorId))} // Clear option only when dropdown is enabled
                            >
                                {years.map((year) => (
                                    <Option key={year} value={year}>
                                        {indicatorId === '14' ? `${year} - ${year + 1}` : year}
                                    </Option>
                                ))}
                            </Select>
                        </div>

                    </>
                ) : (
                    <div style={{ marginBottom: '10px' }}>
                        <Text strong>{t('select-year')}</Text>
                        <Select
                            placeholder={t('select-year')}
                            value={fromYear}
                            style={{ width: '100%', marginTop: '5px' }}
                            onChange={(year) => setFromYear(year as number)}
                            showSearch={true}
                            allowClear
                        >
                            {years.map((year) => (
                                <Option key={year} value={year}>
                                    {year}
                                </Option>
                            ))}
                        </Select>
                    </div>
                )}
            <Button
                type="primary"
                onClick={handleApply}
                style={{ width: '100%', marginBottom: '10px' }}
            >
                {t('text.apply')}
            </Button>
            <Button onClick={handleClearFilter} style={{ width: '100%' }}>
                {t('text.clearfilter')}
            </Button>
        </div>
    );
};

export default FilterContent;
